import { useStaticQuery, graphql } from 'gatsby';

export const useApp = () => {
  const { allMdx } = useStaticQuery(graphql`
    query appsQuery {
      allMdx(
        filter: { fields: { source: { eq: "app-sections" } } }
        sort: { frontmatter: { order: ASC } }
      ) {
        nodes {
          excerpt
          frontmatter {
            description
            divider
            features
            app
            title
            slidesText
            goTo
            reverse
            cover {
              childImageSharp {
                gatsbyImageData
              }
              publicURL
            }
            logo {
              publicURL
            }
            slides {
              childImageSharp {
                gatsbyImageData(transformOptions: { fit: CONTAIN })
              }
              publicURL
            }
          }
        }
      }
    }
  `);

  return (
    allMdx?.nodes.map((appSection) => ({
      excerpt: appSection.excerpt,
      section: appSection.frontmatter
    })) || []
  );
};
